import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid'
import FiltersSection from '../../Filters/FiltersSection'
import withStyles from '@material-ui/core/styles/withStyles'
import { Typography } from '@material-ui/core';
import connect from "react-redux/es/connect/connect";
import {getSOTiresStatistics} from "../../../actions/serviceOrderStatistics";
import TireBrandsParetoChart from "./TireBrandsParetoChart";
import TireModelsParetoChart from "./TireModelsParetoChart";
import TireBandsParetoChart from "./TireBandsParetoChart";
import TireSizesParetoChart from "./TireSizesParetoChart";

import PneusKPIs from "./PneusKPIs";
import {getListaOSheaders} from "../../../actions/orderActions";
import Paper from "@material-ui/core/Paper";
import MaterialTable from "material-table";
import matchSorter from "match-sorter";
import ReactTable from "react-table";
import Card from "../../../common/Card";
import {tableIcons} from "../../../utils/utils";
import {convertISODateTimeToTz} from "../../../common/Util";
// import ListaOSPivotTable from "./listaOSPivotTable";
import ListaOSHeaderCount from "./listaOSHeaderCount";
import ListaOSPivotTable from "./listaOSPivotTable";

//const stations = [1,2,3,4]

const styles = theme => ({
  dashboardSection: {
    // marginTop: "50px"
  },
  sectionTitle: {
    marginBottom: theme.spacing(1) * 4,
    marginTop: theme.spacing(1) * 4
  },
    chartGrid: {
      textAlign: 'center',
        padding: "10px",
    //  marginBottom: "20px"
    }
})

class TiresDashboardView extends Component {
    constructor(props) {
        super(props);

        this.onFilterClick = this.onFilterClick.bind(this);
        this.props.getSOTiresStatistics();
        this.props.getListaOSheaders()
    }
    getColumns() {
        return [
            {
                Header: '#id',
                id: 'osId',
                field: 'osId',
                accessor: 'osId',
                hidden: true

            },
            {
                title: 'O.S.',
                id: 'os',
                field: 'os',
                accessor: 'os',
                hidden: false,
                minWidth: 80,
                maxWidth: 80

            },
            {
                title: 'Data Inicio',
                id: 'DTInicioProducao',
                field: 'DTInicioProducao',
                render: rowData => <Typography note>{convertISODateTimeToTz(rowData.DTInicioProducao)}</Typography>,
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, {keys: ['DTInicioProducao']}),
                filterAll: true,
                minWidth: 180,
                maxWidth: 180
            },
            {
                title: 'Cliente',
                id: 'clienteId',
                field: 'clienteId',
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, {keys: ['clienteId']}),
                filterAll: true,
                minWidth: 80,
                maxWidth: 80

            },
            {
                title: 'Cliente',
                id: 'cliente',
                field: 'descricao',
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, {keys: ['descricao']}),
                filterAll: true,
                minWidth: 200,
                maxWidth: 200
            },
            {
                title: 'Fabricante',
                id: 'fabricante',
                field: 'fabricante',
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, {keys: ["fabricante"]}),
                filterAll: true,
                minWidth: 100,
                maxWidth: 100
            },
            {
                title: 'Modelo',
                id: 'modelo',
                field: 'modelo',
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, {keys: ["modelo"]}),
                filterAll: true,
                minWidth: 150,
                maxWidth: 150
            },
            {
                title: 'Medida',
                id: 'medida',
                field: 'medida',
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, {keys: ["medida"]}),
                filterAll: true,
                minWidth: 150,
                maxWidth: 150
            },
            {
                title: 'Banda',
                id: 'banda',
                field: 'banda',
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, {keys: ["banda"]}),
                filterAll: true,
                minWidth: 150,
                maxWidth: 150
            },
            {
                title: 'Largura',
                id: 'largura',
                field: 'largura',
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, {keys: ["largura"]}),
                filterAll: true,
                minWidth: 50,
                maxWidth: 50
            },
            {
                title: 'Perimetro',
                id: 'perimetro',
                field: 'perimetro',
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, {keys: ["perimetro"]}),
                filterAll: true,
                minWidth: 50,
                maxWidth: 50
            }
        ];
    }

    onFilterClick = () => {
        this.props.getSOTiresStatistics();
        this.props.getListaOSheaders()
    }


    //TODO: reactgridlayout https://github.com/STRML/react-grid-layout
  render() {
    const { classes, listaOSHeader } = this.props;

    console.log('props', this.props);
      console.log(listaOSHeader);
    return (
        <React.Fragment>
            <Grid container direction="column" className={classes.dashboardSection}>
              <Grid item xs={12}>
                <FiltersSection showPeriod={true} showBeforePeriod={false} showBenchPeriod={false} onFilterClick={this.onFilterClick}  loading={this.props.loading} />
              </Grid>
            </Grid>

            <Grid container direction="row" >
                {/*<Grid item xs={12} lg={12} className={classes.chartGrid}>*/}
                {/*    <Typography variant="h4" align="center" className={classes.sectionTitle}>*/}
                {/*        Painel Pneus*/}
                {/*    </Typography>*/}
                {/*</Grid>*/}

                <Grid container item  xs={12} sm={12} lg={12} xl={12}>
                    <Typography variant="h4" align="center" className={classes.sectionTitle}>
                        ORDENS SERVIÇO POR PNEUS
                    </Typography>

                </Grid>

                <Grid item xs={12} className={classes.marginBottom}>
                    <PneusKPIs
                        isLoading={false}
                        fabricantes={this.props.tireStatistics.tireBrands}
                        modelos={this.props.tireStatistics.tireModels.recebidos}
                        modelosfinalizados={this.props.tireStatistics.tireModels.finalizados}

                        bandas={this.props.tireStatistics.tireBands}
                        medidas={this.props.tireStatistics.tireSizes}
                        filter={this.props.filter}
                    />
                </Grid>
                {/*<Grid item  xs={12} lg={12} className={classes.chartGrid} >*/}
                {/*    <TireModelsTreeMap  fabricantes={this.props.tireStatistics.tireBrands} modelos={this.props.tireStatistics.tireModels} filter={this.props.filter} />*/}
                {/*</Grid>*/}
                  <Grid item  xs={6} lg={6} className={classes.chartGrid}>
                      <TireBrandsParetoChart series={this.props.tireStatistics.tireBrands} filter={this.props.filter} />
                  </Grid>

                  <Grid item  xs={6} lg={6} className={classes.chartGrid}>
                      <TireModelsParetoChart series={this.props.tireStatistics.tireModels.recebidos} filter={this.props.filter} />
                  </Grid>
                  <Grid item  xs={6} lg={6} className={classes.chartGrid}>
                      <TireBandsParetoChart series={this.props.tireStatistics.tireBands} filter={this.props.filter} />
                  </Grid>
                  <Grid item  xs={6} lg={6} className={classes.chartGrid}>
                      <TireSizesParetoChart series={this.props.tireStatistics.tireSizes} filter={this.props.filter} />
                  </Grid>

                <Grid item xs={12} lg={12} >
                    <Paper>
                        <MaterialTable
                            icons={tableIcons}
                            columns={this.getColumns()}
                            data={listaOSHeader}
                            title='Ordens de Serviço'
                            options={{
                                filtering: true,
                                pageSize: 15,
                                pageSizeOptions: [10,25,50,100,200],
                            }}
                            // onRowClick={ (e, data) => {
                            //     console.log("row click", e);
                            //     console.log("row click data", data);
                            //     alert(e, false, data.os)
                            // }}
                        />
                    {/*{this.props.listaOSHeader.map( (o,ix) => {*/}
                    {/*   // console.log("OS", o.os);*/}
                    {/*    return (<Typography key={ix} >{o.os}</Typography>)*/}
                    {/*})}*/}
                    </Paper>
                </Grid>

                <Grid item xs={12} lg={12}>
                    <Paper>
                        <ListaOSHeaderCount rows={listaOSHeader}/>
                    </Paper>
                </Grid>

                <Grid item xs={12} lg={12}>
                    <Paper>
                         <ListaOSPivotTable rows={listaOSHeader}/>
                    </Paper>
                </Grid>

            </Grid>
        </React.Fragment>

    );
  }
}

const mapStateToProps = (state) => {
    return {
        tireStatistics: state.serviceOrderStatistics.tireStatistics,
        listaOSHeader: state.ordemServicoReducer.listaOSHeader,
        loading: state.serviceOrderStatistics.isFetchingServiceOrderProductionStatistics,
        filter: state.filter,
        fullreducer: state
    }
}


export default connect(mapStateToProps, {getSOTiresStatistics, getListaOSheaders} ) (withStyles(styles, {withTheme: true})(TiresDashboardView));
